import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/dashboard/Dashboard.vue'
import Controllers from '../components/controller/Controllers.vue';
import Sensors from '../components/sensor/Sensors.vue';
import Actuators from '../components/actuator/Actuators.vue';
import SigninPage from '../components/auth/signin.vue'

import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Dashboard'
    },
    beforeEnter(to, from, next) {
      if (store.state.idToken) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  { path: '/signin', component: SigninPage },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/controllers',
    name: 'Controllers',
    component: Controllers,
    beforeEnter(to, from, next) {
      if (store.state.idToken) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/sensors',
    name: 'Sensors',
    component: Sensors,
    beforeEnter(to, from, next) {
      if (store.state.idToken) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/actuators',
    name: 'Actuators',
    component: Actuators,
    beforeEnter(to, from, next) {
      if (store.state.idToken) {
        next()
      } else {
        next('/signin')
      }
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
